module.exports = __webpack_public_path__ + "img/Rectangle_47.434006df.jpg";